import React, { Fragment, useState } from "react";
import { useFormik } from "formik";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";
import * as Yup from "yup";

import CustomModal from "../../components/modal";

const FaqForm = props => {
  const [inEditMode, setInEditMode] = useState(props.inEditMode);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const switchToEditMode = () => {
    setInEditMode(true);
  };

  const toggleDeleteModal = () => {
    setShowDeleteModal(!showDeleteModal);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: props.faq ? props.faq._id : "",
      question: props.faq ? props.faq.query : "",
      answer: props.faq ? props.faq.ans : ""
    },
    validationSchema: Yup.object({
      question: Yup.string()
        .min(4, "Question must be of minimum length 4")
        .required("Please enter question"),
      answer: Yup.string()
        .min(2, "Answer must be of minimum length 2")
        .required("Please enter answer")
    }),
    onSubmit: values => {
      props.onUpdateFormSubmit(values);

      setInEditMode(false);
    }
  });

  return (
    <Fragment>
      <CustomModal
        okayText="Yes"
        cancelText="No"
        openModal={showDeleteModal}
        cancelEvent={toggleDeleteModal}
        okayEvent={() => {
          props.onFaqDelete(formik.values);
          toggleDeleteModal();
        }}
        modalBodyContent={
          <p className="text-center mb-0">
            Are you sure you want to delete this FAQ?
          </p>
        }
      />

      <form className="d-flex flex-column" onSubmit={formik.handleSubmit}>
        <p className="text-right">
          {inEditMode && (
            <button type="submit" className="btn btn-edit mr-1">
              <i className="fas fa-save"></i>
            </button>
          )}
          {!inEditMode && (
            <button
              onClick={switchToEditMode}
              type="button"
              className="btn btn-edit mr-1"
            >
              <i className="fas fa-edit"></i>
            </button>
          )}
          <button
            onClick={toggleDeleteModal}
            type="button"
            className="btn btn-delete"
          >
            <i className="fas fa-trash-alt"></i>
          </button>
        </p>
        <p>Question {props.questionNo}</p>
        {!inEditMode && (
          <p className="mb-0" style={{ opacity: "0.5" }}>
            {formik.values.question}
          </p>
        )}
        {inEditMode && (
          <TextField
            name="question"
            className="w-100"
            rows="4"
            multiline
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.question}
            error={
              formik.touched.question && formik.errors.question ? true : false
            }
            helperText={
              formik.touched.question && formik.errors.question
                ? formik.errors.question
                : ""
            }
          />
        )}
        <br />
        <p>Answer {props.questionNo}</p>
        {!inEditMode && (
          <p style={{ opacity: "0.5" }}>{formik.values.answer}</p>
        )}
        {inEditMode && (
          <TextField
            name="answer"
            className="w-100"
            rows="5"
            multiline
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.answer}
            error={formik.touched.answer && formik.errors.answer ? true : false}
            helperText={
              formik.touched.answer && formik.errors.answer
                ? formik.errors.answer
                : ""
            }
          />
        )}
      </form>
    </Fragment>
  );
};

export default FaqForm;

FaqForm.defaultProps = {
  questionNo: 1,
  faq: null,
  inEditMode: false,
  onFaqDelete: () => {},
  onUpdateFormSubmit: () => {}
};

FaqForm.propTypes = {
  questionNo: PropTypes.number,
  faq: PropTypes.object,
  onUpdateFormSubmit: PropTypes.func,
  inEditMode: PropTypes.bool,
  onFaqDelete: PropTypes.func
};
